import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loading: 0,
        screenWidth: null,
        bodyHeight: null,
        user: {},
        errors: [],
        messages: [],
        warnings: [],
        webp: window.webp,
        icons: {},
        navData: window.navData,
        active: {},
        updateBodyHeight(){
            const head = document.querySelector('.main-header');
            const foot = document.querySelector('.main-footer');
            if(head && foot){
                const headerTop = parseInt(window.getComputedStyle(head).getPropertyValue('margin-top').match(/\d+/)[0]);
                const headerBottom = parseInt(window.getComputedStyle(head).getPropertyValue('margin-bottom').match(/\d+/)[0]);
                const footerTop = parseInt(window.getComputedStyle(foot).getPropertyValue('margin-top').match(/\d+/)[0]);
                const footerBottom = parseInt(window.getComputedStyle(foot).getPropertyValue('margin-bottom').match(/\d+/)[0]);
                this.bodyHeight = window.innerHeight - 0 - head.getBoundingClientRect().height - foot.getBoundingClientRect().height - headerTop - headerBottom - footerTop - footerBottom;
            }
        }
    }
});